import gql from "graphql-tag"

const PerksMetrics = gql`
  query PerksMetrics($tenantId: ID!){
    perksMetrics(tenantId: $tenantId){
      tenant {
        package
        redemptions_12_weeks
        redemption_count
        estimated_perks_savings
        currency
        last_updated_date
        team_count
        perksgo_count
        perksgo_savings_total
        linked_cards_count
        total_savings
        perks {
          header
          logo_url
          redemption_count
          estimated_perks_savings
        }
      }
    }
  }
`

export default PerksMetrics
